import { Engagement } from 'src/editor/insights/constants';
import { MetricCard, MetricCardsConfig } from '../constants';

const sumReducer = (accumulator: number, currentValue: number) => accumulator + currentValue;

function reduceValueFromEngagements(metricCardConfig: MetricCardsConfig[number], engagements: Engagement[]): number {
  const filteredData = engagements.filter(metricCardConfig.filter);
  return filteredData.map((r: { hit_count: number }) => r.hit_count).reduce(sumReducer, 0);
}
export const convertEngagementsToMetrics = (
  metricCardsConfig: MetricCardsConfig,
  engagements: Engagement[],
  previousEngagements?: Engagement[]
): MetricCard[] => {
  return metricCardsConfig.map((metricCardConfig) => {
    const currentValue = reduceValueFromEngagements(metricCardConfig, engagements);
    const previousValue = previousEngagements
      ? reduceValueFromEngagements(metricCardConfig, previousEngagements)
      : null;
    return {
      value: metricCardConfig.valueCreator(currentValue),
      title: metricCardConfig.title,
      key: metricCardConfig.key,
      ...(previousValue !== null && { delta: currentValue - previousValue }),
      ...(metricCardConfig.tooltipContentCreator && { tooltip: metricCardConfig.tooltipContentCreator(currentValue) }),
    };
  });
};
